import type { CapabilityVisibility } from '@/types/capability-types';

const styles: Record<CapabilityVisibility, string> = {
    global:       'bg-blue-100 text-blue-700',
    organization: 'bg-purple-100 text-purple-700',
    application:  'bg-cyan-100 text-cyan-700',
    account:      'bg-amber-100 text-amber-700',
    user:         'bg-slate-100 text-slate-600',
};

const labels: Record<CapabilityVisibility, string> = {
    global:       'Global',
    organization: 'Organization',
    application:  'Application',
    account:      'Account',
    user:         'User',
};

interface VisibilityBadgeProps {
    value: CapabilityVisibility;
    className?: string;
}

export function VisibilityBadge({ value, className = '' }: VisibilityBadgeProps) {
    const style = styles[value] ?? 'bg-slate-100 text-slate-600';
    const label = labels[value] ?? value;

    return (
        <span
            className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium capitalize ${style} ${className}`}
        >
            {label}
        </span>
    );
}
